import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'PrebuiltBetsSkeleton',
  values: {
    numberOfCards: 3,
    _mobile_numberOfCards: 1,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          overflow: 'hidden',
          _mobile_padding: '8px',
        },
      },
    },
    cardContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '18px',
        style: {
          boxSizing: 'border-box',
          width: '294px',
          _mobile_width: '100%',
          flexDirection: 'column',
          padding: '16px 8px 8px 8px',
          flexGrow: 0,
          flexShrink: 0,
        },
      },
    },
    selectionItemsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    selectionItem: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    iconSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '14px',
          height: '14px',
          borderRadius: '7px',
        },
      },
    },
    selectionTextContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          flexGrow: 0,
        },
      },
    },
    selectionTopRow: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '64px',
          height: '16px',
        },
      },
    },
    selectionBottomRow: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '161px',
          height: '16px',
        },
      },
    },
    selectionButtonContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    selectionButtonSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '100%',
          height: '44px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
